export const PlanterDrawing = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={325}
        height={326}
        fill="none"
        {...props}
    >
        <path
            fill="#fff"
            d="M246.52.11c.696 0 1.367.242 1.901.68l.221.198 75.263 75.264c.563.563.879 1.326.879 2.121v162.085c0 .755-.285 1.482-.798 2.036l-75.393 81.557a3.003 3.003 0 0 1-2.202.963H79.21c-.837 0-1.636-.35-2.204-.964L1.4 242.212a3.002 3.002 0 0 1-.797-2.035L.576 77.959v-.831l.589-.587L77.068.983A3.002 3.002 0 0 1 79.186.11H246.52ZM75.712 7.977v66.89H8.516l-3.94 3.921.028 160.995 2.478 2.683h68.63v74.286l3.935 4.261h166.306l3.463-3.746v-74.749h69.101l2.267-2.454V78.787l-3.868-3.868h-67.448V7.47l-3.363-3.362H79.599l-3.887 3.869Zm173.743 234.491H75.719V74.953h173.736V242.47Z"
        />
        {props.children}
    </svg>
)

